import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import dayjs from 'dayjs';
import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { ChevronRight, ArrowDownToLine } from 'lucide-react';
import Chart from 'react-apexcharts';
import List from './component/list/list';
import axios from 'axios';
import { changeNum, convertDateFormat, convertDate } from './common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function AgentDashboard() {
    let dispatch = useDispatch()
    let navigate = useNavigate()

    let MyData = useSelector((state) => { return state.MyData })

    useEffect(() => {
        dispatch(change_Current_Location("대시보드"))
        dispatch(changeHeaderTitle({
            mainTitle: "대시보드",
            subTitle: ""
        }))
    }, [])

    const [page, setPage] = useState(1)
    const [combineData, setCombineData] = useState([])
    const [agentDashboardToday, setAgentDashboardToday] = useState([])
    const [agentDashboardSum, setAgentDashboardSum] = useState([])
    const [agentSettlement, setAgentSettlement] = useState([])

    // ▼ 추가: 고를 수 있는 연도 목록
    const [yearList, setYearList] = useState([])
    // ▼ 추가: 현재 선택된 연도
    const [selectedYear, setSelectedYear] = useState("")

    useEffect(() => {
        getAgentDashboard()
        getAgentSettlement()

        const interval = setInterval(() => {
            getAgentDashboard();
        }, 10000);

        // 클린업 함수
        return () => {
            clearInterval(interval);
        };
    }, [])

    // 함수 이름이 컴포넌트와 같은 이름이어서 충돌 우려가 있으므로 변경
    const getAgentDashboard = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/agent-dashboard", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                setAgentDashboardToday(tmp?.data?.today[0] ?? [])
                setAgentDashboardSum(tmp?.data?.sum[0] ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const getAgentSettlement = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/agent-settlement/month", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                console.log(tmp)
                setAgentSettlement(tmp?.data ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData1 = [
        { "no": 1, "text": "날짜", "width": "80px", "textAlign": "center" },
        { "no": 2, "text": "정산금액", "width": "110px", "textAlign": "center" },
        { "no": 3, "text": "승인금액", "width": "110px", "textAlign": "center" },
        { "no": 4, "text": "거래수", "width": "80px", "textAlign": "center" },
    ];

    // agentSettlement가 갱신될 때마다 연도 리스트 및 가장 최근 연도 추출
    useEffect(() => {
        if (!agentSettlement || agentSettlement.length === 0) return;

        // "YYYY-MM"에서 "YYYY"만 추출하고 중복 제거
        const years = agentSettlement
            .map(item => item.month.split("-")[0]) // "YYYY-MM"에서 "YYYY" 추출
            .filter((year, idx, arr) => arr.indexOf(year) === idx) // 중복 제거
            .sort((a, b) => parseInt(b) - parseInt(a)); // 오름차순 정렬

        setYearList(years);

        // 가장 높은 연도를 기본값으로 설정
        const latestYear = Math.max(...years.map(yr => parseInt(yr)));
        setSelectedYear(String(latestYear));
    }, [agentSettlement]);

    // agentSettlement 또는 selectedYear가 바뀔 때마다 테이블 데이터 생성
    useEffect(() => {
        if (!agentSettlement || agentSettlement.length === 0 || !selectedYear) {
            setCombineData([]);
            return;
        }

        // selectedYear로 필터링
        const filtered = agentSettlement.filter(item =>
            item.month.startsWith(selectedYear)
        );

        let tableBodyData = filtered.map((data) => ([
            { "no": 1, "text": data.month, "width": "80px", "textAlign": "center" },
            { "no": 2, "text": `${changeNum(Number(data.total_fee))}원`, "width": "110px", "textAlign": "right" },
            { "no": 3, "text": `${changeNum(Number(data.total_amt))}원`, "width": "110px", "textAlign": "right" },
            { "no": 4, "text": `${changeNum(Number(data.total_trx_count))}건`, "width": "80px", "textAlign": "right" },
        ]));

        setCombineData(tableBodyData);
        setPage(1); // 다른 연도 선택 시 페이지를 1로 초기화
    }, [agentSettlement, selectedYear]);

    let filter_tableBodyData = combineData.slice((page - 1) * 12, page * 12);

    return (
        <div className="flex overflow-hidden">
            <div className="content" id="contents">
                <div className="inner-wrap dashboard">
                    <div className="content-container c-left sales">
                        <div className="content-wrap" style={{ paddingBottom: "40px" }}>

                            {/* 실시간 매출 현황 */}
                            <div className="content-item">
                                <div className="main-title-wrap" style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title">실시간 매출 현황</h2>
                                </div>
                                <div className="agent_panel">
                                    <div className="panel agent_panel-1">
                                        <ul>
                                            <li>
                                                <strong className="truncate calc-title">정산금액</strong>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.amount ?? 0)}</money>
                                                    <span>원</span>
                                                </p>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                    <strong className="truncate calc-title">승인금액</strong>
                                                </div>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.trade_amount ?? 0)}</money>
                                                    <span>원</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="panel agent_panel-2">
                                        <ul>
                                            <li>
                                                <strong className="truncate calc-title">에이전트수</strong>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.agent_count ?? 0)}</money>
                                                    <span>명</span>
                                                </p>
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>
                                                <strong className="truncate calc-title">가맹점수</strong>
                                                <p className="calc-item" id="">
                                                    <money id="yesterdayTotalAmount">{changeNum(agentDashboardToday?.merchant_count ?? 0)}</money>
                                                    <span>명</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            {/* 가맹점 정산 */}
                            <div className="content-item">
                                <div className="main-title-wrap" style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                    <h2 className="title">정산</h2>
                                </div>
                                <div className="panel">
                                    <ul>
                                        <li>
                                            <strong className="truncate calc-title">누적 정산금액</strong>
                                            <p className="calc-item" id="">
                                                <money id="yesterdayTotalAmount">{changeNum(agentDashboardSum?.amount ?? 0)}</money>
                                                <span>원</span>
                                            </p>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <strong className="truncate calc-title">누적 승인금액</strong>
                                            </div>
                                            <p className="calc-item" id="">
                                                <money id="yesterdayTotalAmount">{changeNum(agentDashboardSum?.trade_amount ?? 0)}</money>
                                                <span>원</span>
                                            </p>
                                        </li>
                                    </ul>
                                </div>

                                {/* ▼ 연도 선택 셀렉트와 테이블 영역 */}
                                <div className="intro-y box intro-padding">
                                    <select
                                        id="check_gubun"
                                        name="check_gubun"
                                        className="form-select"
                                        style={{ height: "30px", padding: "0 10px", fontSize: "12px", width: "120px" }}
                                        value={selectedYear}
                                        onChange={(e) => setSelectedYear(e.target.value)}
                                    >
                                        {yearList.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>

                                    <List
                                        tableHeaderData={tableHeaderData1}
                                        tableBodyData={combineData}
                                        filter_tableBodyData={filter_tableBodyData}
                                        page={page}
                                        setPage={setPage}
                                        maxFirstPage={12}
                                        height={"auto"}
                                        nonePage={false}
                                    />
                                </div>
                            </div>
                            {/* 가맹점 정산 끝 */}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AgentDashboard;